var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false}},[_c('div',{staticClass:"table-page-search-wrapper"}),_c('div',{staticClass:"table-operator"}),[_vm._v("\n    主动申请考级中心考级点各省统计\n    "),_c('div',{ref:"myEchart",attrs:{"id":"Map"}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }